(function() {
    angular
        .module('emarket.commons')
        .factory('Utils', ['$log', '$location', '$timeout', '$window', '$document', function($log, $location, $timeout, $window, $document) {
            var Util = {};
            Util.getUrl = function() {
                var url = $location.protocol() + '://' + $location.host();
                if ($location.protocol()) {
                    url += ':';
                    $location.protocol();
                }
                return url;
            };
            Util.scrollTo = function(position, selector) {
                // selector = selector || '[ui-view="app"]';
                var element = $document[0].querySelector(selector);
                switch (position) {
                case 'top':
                    if (selector) {
                        element.scrollTop = 0;
                    } else {
                        $window.scrollTo(0, 0);
                    }
                    break;
                case 'bottom':
                case 'button': { //typo deprecated
                    $timeout(function() {
                        if (element) {
                            element.scrollTop = element.scrollHeight;
                        }
                    }, 100);
                    break;
                }
                default:
                    element.scrollBy(0, position);
                }
            };
            Util.blur = function(selector) {
                var element = $document[0].querySelector(selector);
                element.blur();
            };
            Util.focus = function(selector) {
                var element = $document[0].querySelector(selector);
                element.focus();
            };
            return Util;
        }]);
}());
